import Api from '~/types';

export default function mapExtraLevels(
    levels: Array<Api.ExtraShipLevel>,
    isFurther: boolean
): Array<Api.IExtraShipLevel> {
    return levels.map((level) => {
        return { ...level, isFurther };
    });
}
